var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "py-6" }, [
    _c("h3", { staticClass: "text-lg font-medium mb-4" }, [
      _vm._v("Step 8 of 9: Care Goals"),
    ]),
    _c(
      "div",
      { staticClass: "grid grid-cols-1 gap-6" },
      [
        _c("ValidationProvider", {
          attrs: { name: "Short Term Goals" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Short Term Goals "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "short_term_goals",
                          placeholder: "Enter",
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("short_term_goals", val),
                        },
                        model: {
                          value: _vm.formData.short_term_goals,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "short_term_goals", $$v)
                          },
                          expression: "formData.short_term_goals",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Long Term Goals" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "Long Term Goals", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Long Term Goals"),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "long_term_goals",
                          placeholder: "Enter",
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("long_term_goals", val),
                        },
                        model: {
                          value: _vm.formData.long_term_goals,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "long_term_goals", $$v)
                          },
                          expression: "formData.long_term_goals",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Special Care Needs" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Special Care Needs "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "specific_care_needs",
                          placeholder: "Enter",
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("specific_care_needs", val),
                        },
                        model: {
                          value: _vm.formData.specific_care_needs,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "specific_care_needs", $$v)
                          },
                          expression: "formData.specific_care_needs",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Desired Outcomes" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Desired Outcomes "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "desired_outcomes",
                          placeholder: "Enter",
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("desired_outcomes", val),
                        },
                        model: {
                          value: _vm.formData.desired_outcomes,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "desired_outcomes", $$v)
                          },
                          expression: "formData.desired_outcomes",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Self-Directed Care Preferences" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Self-Directed Care Preferences "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          name: "self_directed_care_preferences",
                          placeholder: "Select",
                          getParentCustom: "clientWidth",
                          inputClass: "w-full",
                          options: [
                            {
                              label: "Participatory in Planning",
                              value: "Participatory in Planning",
                            },
                            {
                              label: "Collaborative Approach",
                              value: "Collaborative Approach",
                            },
                            {
                              label: "Minimal Involvement",
                              value: "Minimal Involvement",
                            },
                          ],
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField(
                              "self_directed_care_preferences",
                              val
                            ),
                        },
                        model: {
                          value: _vm.formData.self_directed_care_preferences,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "self_directed_care_preferences",
                              $$v
                            )
                          },
                          expression: "formData.self_directed_care_preferences",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }